const _ = require('lib/underscore')
const LoadingView = require('module/loading_view/loading_view')
const DialogBehavior = require('./dialog_behavior')

const log = require('log').create('dialog', 'loading'); // eslint-disable-line


const LoadingDialogView = LoadingView.extend({

    behaviors() {
        return {
            DialogBehavior: DialogBehavior.config({
                close_button: false,
                click_overlay_to_close: false,
                className: 'loading-dialog',
            }),
        }
    },

})

function loadingDialog(text, options = {}) {
    options.text = text
    _.defaults(options, {
        stacked: true,
    })

    return new LoadingDialogView(options)
}

module.exports = loadingDialog
